import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

/**
 * Reads the current access token from `OAuthService`.
 *
 * The token lives in memory in OAuthService's internal state. We never
 * persist it to localStorage or sessionStorage (per the ecosystem
 * secrets rules in LSLTool's CLAUDE.md). On full page reload the user
 * is prompted to re-authenticate, which is acceptable for this product.
 */
@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  constructor(private oauth: OAuthService) {}

  /** Current access token, or the empty string if not logged in. */
  get token(): string {
    return this.oauth.getAccessToken() || '';
  }

  /** True iff the OAuth library has a non-expired access token. */
  get isAuthenticated(): boolean {
    return this.oauth.hasValidAccessToken();
  }
}
